import { render } from "./EditEventModal.vue?vue&type=template&id=e24d074a"
import script from "./EditEventModal.vue?vue&type=script&lang=js"
export * from "./EditEventModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__